export default "__VITE_ASSET__CZsvE0ER__"